module.exports = __webpack_public_path__ + "img/banner6.426916e4.png";